import { HTMLAttributes } from 'react';

export interface ModalProps extends HTMLAttributes<HTMLDivElement> {
  isOpen: boolean;
  setOpen: (x: boolean) => void;
  onClose?: () => void;
  closeOnClickOutside?: boolean;
  hasCloseIcon?: boolean;
  children?: React.ReactNode;
  size?: ModalSizes;
}

export enum ModalSizes {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}
